window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   */
  trapFocus: function(options) {
    var eventName = options.namespace ?
      'focusin.' + options.namespace :
      'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace ?
      'focusin.' + options.namespace :
      'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};


/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = (
        document.cookie.indexOf('testcookie') !== -1
      );
    }

    return cookieEnabled;
  },

  cart: function() {

    const $productFormAjax = $('.product-form--ajax'),
      $cartDrawer = $('[data-mini-cart]'),
      $itemsContainer = $('[data-mini-cart-items]'),
      $cartItemAlert = $('.bag__item-alert '),
      $checkoutBtn = $('[data-checkout]'),
      skipCartAttr = $productFormAjax.attr('data-skip-cart');

    let skipCart = false;

    if (skipCartAttr == "true") {
      skipCart = true;
    }

    const activeClass = 'is-visible',
      processingClass = 'is-processing';


    /* ============================================================
       PRODUCT FORM SUBMIT
       Pumper può modificare quantità / properties prima del submit.
       ============================================================ */

    $('body').on(
      'submit',
      '.product-form--ajax',
      function(e) {

        e.preventDefault();

        const formData = $(this).serializeArray(),
          formJSON = {};

        $.each(formData, function(i, v) {
          formJSON[v.name] = v.value;
        });

        addItemToCart(formJSON);

      }
    );


    /* ============================================================
       CART QUANTITY

       Usa item.key quando disponibile.
       Questo è più sicuro con bundle / proprietà Pumper.
       ============================================================ */

    $('body').on(
      'change',
      '[data-item-quantity]',
      function() {

        const $input = $(this);

        const itemKey =
          $input.attr('data-item-key');

        const variantId =
          $input.attr('data-variant-id');

        let quantity =
          parseInt($input.val(), 10);

        if (
          isNaN(quantity) ||
          quantity < 0
        ) {
          quantity = 0;
        }

        updateItemQuantity(
          itemKey || variantId,
          quantity
        );

      }
    );


    /* ============================================================
       REMOVE SINGLE ITEM
       ============================================================ */

    $('body').on(
      'click',
      '[data-hp-remove-item]',
      function(e) {

        e.preventDefault();

        const itemKey =
          $(this).attr('data-item-key');

        const variantId =
          $(this).attr('data-variant-id');

        if (
          !itemKey &&
          !variantId
        ) {
          return;
        }

        updateItemQuantity(
          itemKey || variantId,
          0
        );

      }
    );


    /* ============================================================
       CLEAR ENTIRE CART
       ============================================================ */

    $('body').on(
      'click',
      '[data-hp-clear-cart]',
      function(e) {

        e.preventDefault();

        clearCart();

      }
    );


    /* ============================================================
       CHECKOUT
       ============================================================ */

    $checkoutBtn.click(function(e) {

      e.preventDefault();

      const $cartNote =
        $('.js-cart-note');

      if (
        $cartNote.length &&
        $cartNote.val() != ''
      ) {

        updateCartNote(
          $cartNote.val()
        );

      } else {

        window.location.replace(
          '/checkout'
        );

      }

    });


    /* ============================================================
       ADD PRODUCT
       ============================================================ */

    function addItemToCart(data) {

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',

        beforeSend: function() {
          toggleCartControls(false);
        }

      }).done(function(itemData) {

        if (skipCart) {

          window.location.replace(
            '/checkout'
          );

        } else {

          updateCart(true);

        }

      }).fail(function(
        xhr,
        textStatus
      ) {

        console.log(
          "addItemToCart error",
          xhr && xhr.responseText
            ? xhr.responseText
            : textStatus
        );

        toggleCartControls(true);

      });

    }


    /* ============================================================
       CART NOTE
       ============================================================ */

    function updateCartNote(value) {

      $.ajax({

        url: '/cart/update.js',
        type: 'POST',

        data: {
          note: value
        },

        dataType: 'json',

        success: function(result) {

          window.location.replace(
            '/checkout'
          );

        },

        error: function(
          jqxhr,
          status,
          exception
        ) {

          window.location.replace(
            '/checkout'
          );

        }

      });

    }


    /* ============================================================
       GET CURRENT CART
       ============================================================ */

    function updateCart(shouldOpen) {

      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json'

      }).done(function(cartData) {

        updateCartRefs(
          cartData['item_count'],
          cartData['total_price']
        );

        populateCart(
          shouldOpen !== false
        );

      }).fail(function(
        xhr,
        textStatus
      ) {

        console.log(
          "updateCart error"
        );

        toggleCartControls(true);

      });

    }


    /* ============================================================
       REFRESH MINI CART HTML
       ============================================================ */

    function populateCart(shouldOpen) {

      $.get({
        url: '/cart?view=ajax'

      }).done(function(newCartItems) {

        const $newCartItems =
          $.parseHTML(newCartItems);

        $itemsContainer.html(
          $newCartItems
        );

        /*
          Manteniamo il comportamento originale del tema.
        */

        var sections =
          new slate.Sections();

        sections.register(
          'product',
          theme.Product
        );

        toggleCartControls(true);

        if (
          shouldOpen !== false
        ) {
          openCart();
        }

      }).fail(function(
        xhr,
        textStatus
      ) {

        console.log(
          "populateCart error"
        );

        toggleCartControls(true);

      });

    }


    /* ============================================================
       HEADER COUNTER + TOTALS
       ============================================================ */

    function updateCartRefs(
      count,
      total
    ) {

      if (count >= 1) {

        $cartItemAlert.addClass(
          activeClass
        );

      } else {

        $cartItemAlert.removeClass(
          activeClass
        );

      }

      $('[data-cart-total]').html(

        slate.Currency.formatMoney(
          total,
          theme.moneyFormat
        )

      );

    }


    /* ============================================================
       CHANGE LINE ITEM QUANTITY
       ============================================================ */

    function updateItemQuantity(
      id,
      qty
    ) {

      if (!id) {
        return;
      }

      toggleCartControls(false);

      $.ajax({

        type: 'POST',

        url: '/cart/change.js',

        data: {
          id: id,
          quantity: qty
        },

        dataType: 'json'

      }).done(function(cartData) {

        updateCartRefs(
          cartData['item_count'],
          cartData['total_price']
        );

        populateCart(true);

      }).fail(function(
        xhr,
        textStatus
      ) {

        console.log(
          'updateItemQuantity error',
          xhr && xhr.responseText
            ? xhr.responseText
            : textStatus
        );

        toggleCartControls(true);

      });

    }


    /* ============================================================
       CLEAR CART
       ============================================================ */

    function clearCart() {

      toggleCartControls(false);

      $.ajax({

        type: 'POST',

        url: '/cart/clear.js',

        dataType: 'json'

      }).done(function(cartData) {

        updateCartRefs(
          0,
          0
        );

        populateCart(true);

      }).fail(function(
        xhr,
        textStatus
      ) {

        console.log(
          'clearCart error',
          xhr && xhr.responseText
            ? xhr.responseText
            : textStatus
        );

        toggleCartControls(true);

      });

    }


    /* ============================================================
       ENABLE / DISABLE CART CONTROLS
       ============================================================ */

    function toggleCartControls(
      status
    ) {

      const $currentQtyControls =
        $('.product__quantity-wrapper--cart button');

      const $currentQtyInputs =
        $('[data-item-quantity]');

      const $currentRemoveButtons =
        $('[data-hp-remove-item]');

      const $currentClearButton =
        $('[data-hp-clear-cart]');

      const $currentCheckoutBtn =
        $('[data-checkout]');


      if (status === true) {

        $currentQtyControls
          .removeAttr('disabled')
          .removeClass(processingClass);

        $currentQtyInputs
          .removeAttr('disabled')
          .removeClass(processingClass);

        $currentRemoveButtons
          .removeAttr('disabled')
          .removeClass(processingClass);

        $currentClearButton
          .removeAttr('disabled')
          .removeClass(processingClass);

        $currentCheckoutBtn
          .removeAttr('disabled')
          .removeClass(processingClass);

      } else {

        $currentQtyControls
          .attr(
            'disabled',
            'disabled'
          )
          .addClass(processingClass);

        $currentQtyInputs
          .attr(
            'disabled',
            'disabled'
          )
          .addClass(processingClass);

        $currentRemoveButtons
          .attr(
            'disabled',
            'disabled'
          )
          .addClass(processingClass);

        $currentClearButton
          .attr(
            'disabled',
            'disabled'
          )
          .addClass(processingClass);

        $currentCheckoutBtn
          .attr(
            'disabled',
            'disabled'
          )
          .addClass(processingClass);

      }

    }


    /* ============================================================
       OPEN DRAWER
       ============================================================ */

    function openCart() {

      $cartDrawer.addClass(
        activeClass
      );

      $('body').addClass(
        'no-scroll'
      );

    }


    /* ============================================================
       DISCOUNT FIELD
       ============================================================ */

    let checkoutUrl =
      '/checkout?discount=';

    $('.mini-cart').on(
      'click',
      '.js-cart-discount-action',
      function() {

        const $discountField =
          $('.js-cart-discount');

        const discount =
          $discountField.val();

        if (
          discount != '' &&
          typeof discount !== 'undefined'
        ) {

          const discountUrl =
            checkoutUrl + discount;

          window.location.href =
            discountUrl;

        }

      }
    );

  }
};


/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 */

slate.utils = {

  findInstance: function(
    array,
    key,
    value
  ) {

    for (
      var i = 0;
      i < array.length;
      i++
    ) {

      if (
        array[i][key] === value
      ) {
        return array[i];
      }

    }

  },


  removeInstance: function(
    array,
    key,
    value
  ) {

    var i =
      array.length;

    while (i--) {

      if (
        array[i][key] === value
      ) {

        array.splice(
          i,
          1
        );

        break;

      }

    }

    return array;

  },


  compact: function(array) {

    var index = -1;
    var length =
      array == null
        ? 0
        : array.length;

    var resIndex = 0;
    var result = [];

    while (++index < length) {

      var value =
        array[index];

      if (value) {

        result[
          resIndex++
        ] = value;

      }

    }

    return result;

  },


  defaultTo: function(
    value,
    defaultValue
  ) {

    return (
      value == null ||
      value !== value
    )
      ? defaultValue
      : value;

  }

};


/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 */

slate.rte = {

  wrapTable: function(options) {

    var tableWrapperClass =
      typeof options.tableWrapperClass === "undefined"
        ? ''
        : options.tableWrapperClass;

    options.$tables.wrap(
      '<div class="' +
      tableWrapperClass +
      '"></div>'
    );

  },


  wrapIframe: function(options) {

    var iframeWrapperClass =
      typeof options.iframeWrapperClass === "undefined"
        ? ''
        : options.iframeWrapperClass;

    options.$iframes.each(
      function() {

        $(this).wrap(
          '<div class="' +
          iframeWrapperClass +
          '"></div>'
        );

        this.src =
          this.src;

      }
    );

  }

};


/**
 * Product Template Script
 * -----------------------------------------------------------------------------
 */

theme.Header = (function() {

  $(document).ready(
    function() {

      let $menuToggle =
        $('[data-toggle-mega-menu]');

      let $megaMenu =
        $('[data-mega-menu]');


      $menuToggle.click(
        function() {

          $menuToggle.toggleClass(
            'active'
          );

          $megaMenu.toggleClass(
            'active'
          );

        }
      );


      $('[data-has-dropdown]').click(
        function(e) {
          e.preventDefault();
        }
      );


      $('[data-toggle-mobile-submenu]').click(
        function(e) {

          $(this)
            .closest('li')
            .find(
              '[data-toggle-mobile-submenu]'
            )
            .not(this)
            .next(
              '.header__nav__mega-nav__sub-list'
            )
            .removeClass(
              'active'
            );

          $(this)
            .next(
              '.header__nav__mega-nav__sub-list'
            )
            .toggleClass(
              'active'
            );

          e.preventDefault();

        }
      );


      let lastScrollTop = 0;

      const $productForm =
        $('.product-form');

      const $productFormAtc =
        $productForm.find(
          '[data-add-to-cart]'
        );

      const $headerPdp =
        $('.header--reveal');

      const $headerAtc =
        $('.header__atc');

      var scrollTimeout;

      var throttle =
        300;


      if ($headerPdp.length) {

        $(window).scroll(
          function(event) {

            const $atcOffset =
              $productForm.offset().top +
              $productForm.outerHeight(true);

            if (!scrollTimeout) {

              scrollTimeout =
                setTimeout(
                  function() {

                    let st =
                      $(this).scrollTop();

                    if (
                      st < $atcOffset
                    ) {

                      $headerPdp.addClass(
                        'active'
                      );

                      $headerAtc.removeClass(
                        'active'
                      );

                    } else {

                      $headerPdp.removeClass(
                        'active'
                      );

                      $headerAtc.addClass(
                        'active'
                      );

                    }

                    scrollTimeout =
                      null;

                  },
                  throttle
                );

            }

          }
        );

      }


      $('.js-header-atc').click(
        function() {

          $productForm.submit();

        }
      );

    }
  );

})();


slate.Sections =
function Sections() {

  this.constructors = {};
  this.instances = [];

  $(document)

    .on(
      'shopify:section:load',
      this._onSectionLoad.bind(this)
    )

    .on(
      'shopify:section:unload',
      this._onSectionUnload.bind(this)
    )

    .on(
      'shopify:section:select',
      this._onSelect.bind(this)
    )

    .on(
      'shopify:section:deselect',
      this._onDeselect.bind(this)
    )

    .on(
      'shopify:section:reorder',
      this._onReorder.bind(this)
    )

    .on(
      'shopify:block:select',
      this._onBlockSelect.bind(this)
    )

    .on(
      'shopify:block:deselect',
      this._onBlockDeselect.bind(this)
    );

};


slate.Sections.prototype =
$.extend(
  {},
  slate.Sections.prototype,
  {

    _createInstance: function(
      container,
      constructor
    ) {

      var $container =
        $(container);

      var id =
        $container.attr(
          'data-section-id'
        );

      var type =
        $container.attr(
          'data-section-type'
        );

      constructor =
        constructor ||
        this.constructors[type];

      if (
        typeof constructor ===
        'undefined'
      ) {
        return;
      }

      var instance =
        $.extend(
          new constructor(
            container
          ),
          {
            id: id,
            type: type,
            container: container
          }
        );

      this.instances.push(
        instance
      );

    },


    _onSectionLoad: function(evt) {

      var container =
        $('[data-section-id]', evt.target)[0];

      var $container =
        $('[data-section-id]', evt.target);

      if (container) {

        this._createInstance(
          container
        );


        let $heroSlider =
          $container;

        if (
          $heroSlider.hasClass(
            'hero-slider'
          )
        ) {

          let enableDots =
            (
              $heroSlider.attr(
                'data-dots'
              ) == 'true'
            );

          let enableArrows =
            (
              $heroSlider.attr(
                'data-arrows'
              ) == 'true'
            );

          let enableAutoplay =
            (
              $heroSlider.attr(
                'data-autoplay'
              ) == 'true'
            );

          let duration =
            parseInt(
              $heroSlider.attr(
                'data-duration'
              )
            );


          $heroSlider.slick({

            arrows:
              enableArrows,

            dots:
              enableDots,

            slidesToShow:
              1,

            slidesToScroll:
              1,

            autoplay:
              enableAutoplay,

            autoplaySpeed:
              duration,

            prevArrow:
              '<span class="fas fa-chevron-left arrow--left"></span>',

            nextArrow:
              '<span class="fas fa-chevron-right arrow--right"></span>'

          });

        }


        const headerHeight =
          $('.header').height();

        const productInfoSpacing =
          30;

        const $productImageSlider =
          $container.find(
            '.product__images-slider'
          );


        if (
          $productImageSlider.length
        ) {

          const numOfThumbnails =
            $container
              .find(
                '.product__images-thumbs > img'
              )
              .length;

          let slickCenterMode =
            false;

          if (
            numOfThumbnails >= 4
          ) {
            slickCenterMode =
              true;
          }


          $productImageSlider.slick({

            slidesToShow:
              1,

            slidesToScroll:
              1,

            fade:
              true,

            prevArrow:
              '<span class="fas fa-chevron-left arrow--left"></span>',

            nextArrow:
              '<span class="fas fa-chevron-right arrow--right"></span>'

          });


          if (
            numOfThumbnails > 1
          ) {

            $container
              .find(
                '.product__images-thumbs'
              )
              .slick({

                slidesToShow:
                  4,

                slidesToScroll:
                  2,

                arrows:
                  false,

                centerMode:
                  slickCenterMode,

                focusOnSelect:
                  true,

                asNavFor:
                  '.product__images-slider'

              });

          }

        }

      }

    },


    _onSectionUnload: function(
      evt
    ) {

      var instance =
        slate.utils.findInstance(
          this.instances,
          'id',
          evt.detail.sectionId
        );

      if (!instance) {
        return;
      }

      if (
        typeof instance.onUnload ===
        'function'
      ) {

        instance.onUnload(
          evt
        );

      }

      this.instances =
        slate.utils.removeInstance(
          this.instances,
          'id',
          evt.detail.sectionId
        );

    },


    _onSelect: function(evt) {

      var instance =
        slate.utils.findInstance(
          this.instances,
          'id',
          evt.detail.sectionId
        );

      var $container =
        $('[data-section-id]', evt.target);

      var containerId =
        $container.attr('id');


      const $popup =
        $('.pop-up-modal', evt.target);

      const $popupFloat =
        $('.pop-up-float', evt.target);

      const $popupModalClose =
        $('.pop-up-modal__close--trigger', evt.target);

      const $popupFloatClose =
        $('.pop-up-float__close', evt.target);

      const $triggerPopupContainer =
        $('.pop-up-trigger', evt.target);

      const $triggerPopup =
        $('.pop-up-trigger__trigger', evt.target);

      const $triggerPopupClose =
        $('.pop-up-trigger__close', evt.target);

      const popupActiveClass =
        'active';


      if ($popup.length) {

        $popup.addClass(
          'active'
        );

      } else {

        if (
          $('.pop-up-modal').length
        ) {

          $('.pop-up-modal')
            .removeClass(
              'active'
            );

        }

      }


      if ($popupFloat.length) {

        $popupFloat.addClass(
          'active'
        );

      } else {

        if (
          $('.pop-up-float').length
        ) {

          $('.pop-up-float')
            .removeClass(
              'active'
            );

        }

      }


      if (
        $triggerPopupContainer.length
      ) {

        $triggerPopupContainer.addClass(
          'active'
        );

      } else {

        if (
          $('.pop-up-trigger').length
        ) {

          $('.pop-up-trigger')
            .removeClass(
              'active'
            );

        }

      }


      $triggerPopup.click(
        function() {

          $popupFloat.addClass(
            popupActiveClass
          );

        }
      );


      $popupFloatClose.click(
        function() {

          $popupFloat.removeClass(
            popupActiveClass
          );

        }
      );


      $triggerPopupClose.click(
        function() {

          $triggerPopupContainer.removeClass(
            popupActiveClass
          );

        }
      );


      $popupModalClose.click(
        function() {

          $popup.hide();

        }
      );


      $popup.find('form').submit(
        function() {

          $popupFloat.hide();

          $triggerPopupContainer.hide();

        }
      );


      const $heroSlider =
        $('.hero-slider');

      if (
        $heroSlider.length
      ) {

        $heroSlider.each(
          function() {

            let enableDots =
              (
                $(this).attr(
                  'data-dots'
                ) == 'true'
              );

            let enableArrows =
              (
                $(this).attr(
                  'data-arrows'
                ) == 'true'
              );

            let enableAutoplay =
              (
                $(this).attr(
                  'data-autoplay'
                ) == 'true'
              );

            let duration =
              parseInt(
                $(this).attr(
                  'data-duration'
                )
              );


            $(this).slick({

              arrows:
                enableArrows,

              dots:
                enableDots,

              slidesToShow:
                1,

              slidesToScroll:
                1,

              autoplay:
                enableAutoplay,

              autoplaySpeed:
                duration,

              prevArrow:
                '<span class="fas fa-chevron-left arrow--left"></span>',

              nextArrow:
                '<span class="fas fa-chevron-right arrow--right"></span>'

            });

          }
        );

      }


      const headerHeight =
        $('.header').height();

      const productInfoSpacing =
        30;

      const $productImageSlider =
        $('.product__images-slider');


      if (
        $productImageSlider.length
      ) {

        const numOfThumbnails =
          $('.product__images-thumbs > img')
            .length;

        let slickCenterMode =
          false;

        if (
          numOfThumbnails >= 4
        ) {
          slickCenterMode =
            true;
        }


        $productImageSlider.slick({

          slidesToShow:
            1,

          slidesToScroll:
            1,

          fade:
            true,

          prevArrow:
            '<span class="fas fa-chevron-left arrow--left"></span>',

          nextArrow:
            '<span class="fas fa-chevron-right arrow--right"></span>'

        });


        if (
          numOfThumbnails > 1
        ) {

          $('.product__images-thumbs')
            .slick({

              slidesToShow:
                4,

              slidesToScroll:
                2,

              arrows:
                false,

              centerMode:
                slickCenterMode,

              focusOnSelect:
                true,

              asNavFor:
                '.product__images-slider'

            });

        }

      }


      if (
        instance &&
        typeof instance.onSelect ===
        'function'
      ) {

        instance.onSelect(
          evt
        );

      }

    },


    _onDeselect: function(evt) {

      var instance =
        slate.utils.findInstance(
          this.instances,
          'id',
          evt.detail.sectionId
        );

      if (
        instance &&
        typeof instance.onDeselect ===
        'function'
      ) {

        instance.onDeselect(
          evt
        );

      }

    },


    _onReorder: function(evt) {

      var instance =
        slate.utils.findInstance(
          this.instances,
          'id',
          evt.detail.sectionId
        );

      if (
        instance &&
        typeof instance.onReorder ===
        'function'
      ) {

        instance.onReorder(
          evt
        );

      }

    },


    _onBlockSelect: function(evt) {

      var instance =
        slate.utils.findInstance(
          this.instances,
          'id',
          evt.detail.sectionId
        );

      if (
        instance &&
        typeof instance.onBlockSelect ===
        'function'
      ) {

        instance.onBlockSelect(
          evt
        );

      }

    },


    _onBlockDeselect: function(evt) {

      var instance =
        slate.utils.findInstance(
          this.instances,
          'id',
          evt.detail.sectionId
        );

      if (
        instance &&
        typeof instance.onBlockDeselect ===
        'function'
      ) {

        instance.onBlockDeselect(
          evt
        );

      }

    },


    register: function(
      type,
      constructor
    ) {

      this.constructors[type] =
        constructor;

      $(
        '[data-section-type=' +
        type +
        ']'
      ).each(
        function(
          index,
          container
        ) {

          this._createInstance(
            container,
            constructor
          );

        }.bind(this)
      );

    }

  }
);


/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 */

slate.Currency =
(function() {

  var moneyFormat =
    '${{amount}}';


  function formatMoney(
    cents,
    format
  ) {

    if (
      typeof cents ===
      'string'
    ) {

      cents =
        cents.replace(
          '.',
          ''
        );

    }


    var value =
      '';

    var placeholderRegex =
      /\{\{\s*(\w+)\s*\}\}/;

    var formatString =
      (
        format ||
        moneyFormat
      );


    function formatWithDelimiters(
      number,
      precision,
      thousands,
      decimal
    ) {

      precision =
        slate.utils.defaultTo(
          precision,
          2
        );

      thousands =
        slate.utils.defaultTo(
          thousands,
          ','
        );

      decimal =
        slate.utils.defaultTo(
          decimal,
          '.'
        );


      if (
        isNaN(number) ||
        number == null
      ) {
        return 0;
      }


      number =
        (
          number / 100.0
        ).toFixed(
          precision
        );


      var parts =
        number.split('.');


      var dollarsAmount =
        parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );


      var centsAmount =
        parts[1]
          ? (
              decimal +
              parts[1]
            )
          : '';


      return (
        dollarsAmount +
        centsAmount
      );

    }


    switch (
      formatString
        .match(
          placeholderRegex
        )[1]
    ) {

      case 'amount':

        value =
          formatWithDelimiters(
            cents,
            2
          );

        break;


      case 'amount_no_decimals':

        value =
          formatWithDelimiters(
            cents,
            0
          );

        break;


      case 'amount_with_comma_separator':

        value =
          formatWithDelimiters(
            cents,
            2,
            '.',
            ','
          );

        break;


      case 'amount_no_decimals_with_comma_separator':

        value =
          formatWithDelimiters(
            cents,
            0,
            '.',
            ','
          );

        break;

    }


    return formatString.replace(
      placeholderRegex,
      value
    );

  }


  return {
    formatMoney:
      formatMoney
  };

})();


/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 */

slate.Image =
(function() {


  function preload(
    images,
    size
  ) {

    if (
      typeof images ===
      'string'
    ) {
      images = [
        images
      ];
    }


    for (
      var i = 0;
      i < images.length;
      i++
    ) {

      var image =
        images[i];

      this.loadImage(
        this.getSizedImageUrl(
          image,
          size
        )
      );

    }

  }


  function loadImage(path) {
    new Image().src =
      path;
  }


  function imageSize(src) {

    var match =
      src.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      );


    if (match) {

      return match[1];

    } else {

      return null;

    }

  }


  function getSizedImageUrl(
    src,
    size
  ) {

    if (
      size === null
    ) {
      return src;
    }


    if (
      size === 'master'
    ) {

      return this.removeProtocol(
        src
      );

    }


    var match =
      src.match(
        /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
      );


    if (match) {

      var prefix =
        src.split(
          match[0]
        );

      var suffix =
        match[0];


      return this.removeProtocol(
        prefix[0] +
        '_' +
        size +
        suffix
      );

    } else {

      return null;

    }

  }


  function removeProtocol(path) {

    return path.replace(
      /http(s)?:/,
      ''
    );

  }


  return {

    preload:
      preload,

    loadImage:
      loadImage,

    imageSize:
      imageSize,

    getSizedImageUrl:
      getSizedImageUrl,

    removeProtocol:
      removeProtocol

  };

})();


/**
 * Variant Selection scripts
 * -----------------------------------------------------------------------------
 */

slate.Variants =
(function() {


  function Variants(options) {

    this.$container =
      options.$container;

    this.product =
      options.product;

    this.singleOptionSelector =
      options.singleOptionSelector;

    this.originalSelectorId =
      options.originalSelectorId;

    this.enableHistoryState =
      options.enableHistoryState;

    this.currentVariant =
      this._getVariantFromOptions();


    $(this.$container).on(

      'change',

      this.singleOptionSelector,

      this._onSelectChange.bind(
        this
      )

    );

  }


  Variants.prototype =
    $.extend(
      {},
      Variants.prototype,
      {


        _getCurrentOptions:
        function() {

          var currentOptions =
            $.map(

              $(
                this.singleOptionSelector,
                this.$container
              ),

              function(element) {

                var $element =
                  $(element);

                var type =
                  $element.attr(
                    'type'
                  );

                var currentOption =
                  {};


                if (
                  type === 'radio' ||
                  type === 'checkbox'
                ) {

                  if (
                    $element[0].checked
                  ) {

                    currentOption.value =
                      $element.val();

                    currentOption.index =
                      $element.data(
                        'index'
                      );

                    return currentOption;

                  } else {

                    return false;

                  }

                } else {

                  currentOption.value =
                    $element.val();

                  currentOption.index =
                    $element.data(
                      'index'
                    );

                  return currentOption;

                }

              }

            );


          currentOptions =
            slate.utils.compact(
              currentOptions
            );


          return currentOptions;

        },


        _getVariantFromOptions:
        function() {

          var selectedValues =
            this._getCurrentOptions();

          var variants =
            this.product.variants;

          var found =
            false;


          variants.forEach(
            function(variant) {

              var satisfied =
                true;


              selectedValues.forEach(
                function(option) {

                  if (satisfied) {

                    satisfied =
                      (
                        option.value ===
                        variant[
                          option.index
                        ]
                      );

                  }

                }
              );


              if (satisfied) {

                found =
                  variant;

              }

            }
          );


          return (
            found ||
            null
          );

        },


        _onSelectChange:
        function() {

          var variant =
            this._getVariantFromOptions();


          this.$container.trigger({
            type:
              'variantChange',

            variant:
              variant
          });


          if (!variant) {
            return;
          }


          this._updateMasterSelect(
            variant
          );

          this._updateImages(
            variant
          );

          this._updatePrice(
            variant
          );

          this.currentVariant =
            variant;


          if (
            this.enableHistoryState
          ) {

            this._updateHistoryState(
              variant
            );

          }

        },


        _updateImages:
        function(variant) {

          var variantImage =
            variant.featured_image ||
            {};

          var currentVariantImage =
            this.currentVariant.featured_image ||
            {};

          var variantImageId =
            '';


          if (
            variant.featured_image !==
            null
          ) {

            variantImageId =
              variant.featured_image.id;

          }


          if (
            !variant.featured_image ||
            variantImage.src ===
            currentVariantImage.src
          ) {
            return;
          }


          const $variantImage =
            $(
              '[data-image-id="' +
              variantImageId +
              '"]'
            ).closest(
              '.product__image'
            );


          const variantImageIndex =
            parseInt(
              $variantImage.attr(
                'data-slick-index'
              )
            );


          const $slider =
            $('.product__images-slider');


          if (
            $variantImage.length &&
            $slider.length
          ) {

            console.log(
              variantImageIndex
            );

            $slider.slick(
              'slickGoTo',
              variantImageIndex
            );

          }


          this.$container.trigger({

            type:
              'variantImageChange',

            variant:
              variant

          });

        },


        _updatePrice:
        function(variant) {

          if (
            variant.price ===
              this.currentVariant.price &&
            variant.compare_at_price ===
              this.currentVariant.compare_at_price
          ) {
            return;
          }


          this.$container.trigger({

            type:
              'variantPriceChange',

            variant:
              variant

          });

        },


        _updateHistoryState:
        function(variant) {

          if (
            !history.replaceState ||
            !variant
          ) {
            return;
          }


          var newurl =

            window.location.protocol +

            '//' +

            window.location.host +

            window.location.pathname +

            '?variant=' +

            variant.id;


          window.history.replaceState(
            {
              path:
                newurl
            },
            '',
            newurl
          );

        },


        _updateMasterSelect:
        function(variant) {

          $(
            this.originalSelectorId,
            this.$container
          )[0].value =
            variant.id;

        }

      }

    );


  return Variants;

})();


/*================ Sections ================*/

/**
 * Product Template Script
 * -----------------------------------------------------------------------------
 */

theme.Product =
(function() {


  var selectors = {

    addToCart:
      '[data-add-to-cart]',

    addToCartText:
      '[data-add-to-cart-text]',

    comparePrice:
      '[data-compare-price]',

    percentageDiscount:
      '.js-percentage-discount',

    comparePriceText:
      '[data-compare-text]',

    originalSelectorId:
      '[data-product-select]',

    priceWrapper:
      '[data-price-wrapper]',

    productFeaturedImage:
      '[data-product-featured-image]',

    productJson:
      '[data-product-json]',

    productPrice:
      '[data-product-price]',

    productThumbs:
      '[data-product-single-thumbnail]',

    singleOptionSelector:
      '[data-single-option-selector]'

  };


  function Product(container) {

    this.$container =
      $(container);


    if (
      !$(selectors.productJson, this.$container)
        .html()
    ) {
      return;
    }


    var sectionId =
      this.$container.attr(
        'data-section-id'
      );


    this.productSingleObject =
      JSON.parse(

        $(
          selectors.productJson,
          this.$container
        ).html()

      );


    var options = {

      $container:
        this.$container,

      enableHistoryState:
        this.$container.data(
          'enable-history-state'
        ) || false,

      singleOptionSelector:
        selectors.singleOptionSelector,

      originalSelectorId:
        selectors.originalSelectorId,

      product:
        this.productSingleObject

    };


    this.settings = {};

    this.namespace =
      '.product';

    this.variants =
      new slate.Variants(
        options
      );

    this.$featuredImage =
      $(
        selectors.productFeaturedImage,
        this.$container
      );


    this.$container.on(

      'variantChange' +
      this.namespace,

      this.updateAddToCartState.bind(
        this
      )

    );


    this.$container.on(

      'variantPriceChange' +
      this.namespace,

      this.updateProductPrices.bind(
        this
      )

    );


    if (
      this.$featuredImage.length >
      0
    ) {

      this.settings.imageSize =
        slate.Image.imageSize(
          this.$featuredImage.attr(
            'src'
          )
        );


      slate.Image.preload(

        this.productSingleObject.images,

        this.settings.imageSize

      );


      this.$container.on(

        'variantImageChange' +
        this.namespace,

        this.updateProductImage.bind(
          this
        )

      );

    }

  }


  Product.prototype =
    $.extend(
      {},
      Product.prototype,
      {


        updateAddToCartState:
        function(evt) {

          var variant =
            evt.variant;


          if (variant) {

            $(
              selectors.priceWrapper
            ).removeClass(
              'hide'
            );

          } else {

            $(
              selectors.addToCart
            ).prop(
              'disabled',
              true
            );

            $(
              selectors.addToCartText
            ).html(
              theme.strings.unavailable
            );

            $(
              selectors.priceWrapper
            ).addClass(
              'hide'
            );

            return;

          }


          if (
            variant.available
          ) {

            $(
              selectors.addToCart
            ).prop(
              'disabled',
              false
            );

            $(
              selectors.addToCartText
            ).html(
              theme.strings.addToCart
            );

          } else {

            $(
              selectors.addToCart
            ).prop(
              'disabled',
              true
            );

            $(
              selectors.addToCartText
            ).html(
              theme.strings.soldOut
            );

          }

        },


        updateProductPrices:
        function(evt) {

          var variant =
            evt.variant;

          var $comparePrice =
            $(
              selectors.comparePrice
            );

          var $compareEls =
            $comparePrice.add(
              selectors.comparePriceText
            );

          const $discount =
            $(
              selectors.percentageDiscount
            ).closest(
              '.sale-percentage'
            );


          const saleClass =
            "on-sale";


          $(
            selectors.productPrice
          ).html(

            slate.Currency.formatMoney(
              variant.price,
              theme.moneyFormat
            )

          );


          if (
            variant.compare_at_price >
            variant.price
          ) {

            const percentage =
              Math.round(

                (
                  (
                    variant.compare_at_price -
                    variant.price
                  ) /
                  variant.compare_at_price
                ) *
                100

              );


            $(
              selectors.productPrice
            ).addClass(
              saleClass
            );


            $comparePrice.html(

              slate.Currency.formatMoney(
                variant.compare_at_price,
                theme.moneyFormat
              )

            );


            $(
              selectors.percentageDiscount
            ).html(
              percentage
            );


            $discount.removeClass(
              'hide'
            );

            $compareEls.removeClass(
              'hide'
            );

          } else {

            $(
              selectors.productPrice
            ).removeClass(
              saleClass
            );


            $comparePrice.html(
              ''
            );


            $discount.addClass(
              'hide'
            );

            $compareEls.addClass(
              'hide'
            );

          }

        },


        updateProductImage:
        function(evt) {

          var variant =
            evt.variant;


          var sizedImgUrl =
            slate.Image.getSizedImageUrl(

              variant.featured_image.src,

              this.settings.imageSize

            );


          this.$featuredImage.attr(
            'src',
            sizedImgUrl
          );

        },


        onUnload:
        function() {

          this.$container.off(
            this.namespace
          );

        }

      }

    );


  /* ============================================================
     PRODUCT / CART QUANTITY BUTTONS
     ============================================================ */

  $('body').on(
    'click',
    '.qty-control',
    function() {

      const $qty =
        $(this)
          .closest(
            '.product__quantity-wrapper'
          )
          .find(
            '.product__quantity'
          );


      const control =
        $(this).attr(
          'data-control'
        );


      const isCartQty =
        $qty.hasClass(
          'product__quantity--cart'
        );


      let val =
        $qty.val();


      if (
        control ==
        "up"
      ) {

        val++;

      } else if (
        control ==
        "down"
      ) {

        if (
          isCartQty &&
          val >= 1
        ) {

          val--;

        } else if (
          !isCartQty &&
          val >= 2
        ) {

          val--;

        }

      }


      $qty.val(
        val
      );


      $qty.trigger(
        'change'
      );

    }
  );


  /* ============================================================
     PRODUCT HERO VIDEO
     ============================================================ */

  $('.js-open-video').click(
    function(e) {

      const $videoModal =
        $(this)
          .closest(
            '.video__hero'
          )
          .next(
            '.video__modal'
          );


      const $ytEmbed =
        $videoModal.find(
          'iframe'
        );


      const ytUrl =
        $(this).attr(
          'data-video-url'
        );


      if (
        $(this).hasClass(
          'video__hero__btn'
        )
      ) {

        const ytArr =
          ytUrl.split(
            'watch?v='
          );


        const ytId =
          ytArr[
            ytArr.length - 1
          ];


        const embedUrl =
          "https://www.youtube.com/embed/" +
          ytId +
          "?autoplay=1";


        $ytEmbed[0].src =
          embedUrl;

      } else {

        $ytEmbed[0].src =
          "";

      }


      $videoModal.addClass(
        'active'
      );


      $('body').addClass(
        'no-scroll'
      );


      e.preventDefault();

    }
  );


  $('.video__modal')
    .not(
      '.video__modal__content'
    )
    .click(
      function() {

        const $ytEmbed =
          $(this).find(
            'iframe'
          );


        $ytEmbed[0].src =
          "";


        $(this).removeClass(
          'active'
        );


        $('body').removeClass(
          'no-scroll'
        );

      }
    );


  return Product;

})();


/* ============================================================
   QUICK CART OPEN / CLOSE
   ============================================================ */

let quickCart =
  document.querySelector(
    '.mini-cart'
  );


function openQuickCart(e) {

  e.preventDefault();

  quickCart.classList.toggle(
    'is-visible'
  );

}


$('[data-toggle-bag]').on(
  'click',
  function(evt) {

    openQuickCart(
      evt
    );


    if (
      quickCart.classList.contains(
        'is-visible'
      )
    ) {

      document.body.classList.add(
        'no-scroll'
      );

    } else {

      document.body.classList.remove(
        'no-scroll'
      );

    }

  }
);


/* ============================================================
   HERO SLIDER
   ============================================================ */

const $heroSlider =
  $('.hero-slider');


let enableDots =
    (
      $heroSlider.attr(
        'data-dots'
      ) == 'true'
    ),

  enableArrows =
    (
      $heroSlider.attr(
        'data-arrows'
      ) == 'true'
    ),

  enableAutoplay =
    (
      $heroSlider.attr(
        'data-autoplay'
      ) == 'true'
    ),

  duration =
    parseInt(
      $heroSlider.attr(
        'data-duration'
      )
    );


if (
  $heroSlider.length
) {

  $heroSlider.slick({

    arrows:
      enableArrows,

    dots:
      enableDots,

    slidesToShow:
      1,

    slidesToScroll:
      1,

    autoplay:
      enableAutoplay,

    autoplaySpeed:
      duration,

    prevArrow:
      '<span class="fas fa-chevron-left arrow--left"></span>',

    nextArrow:
      '<span class="fas fa-chevron-right arrow--right"></span>'

  });

}


/*================ Templates ================*/

/**
 * Customer Addresses Script
 * -----------------------------------------------------------------------------
 */

theme.customerAddresses =
(function() {

  var $newAddressForm =
    $('#AddressNewForm');


  if (
    !$newAddressForm.length
  ) {
    return;
  }


  if (Shopify) {

    new Shopify.CountryProvinceSelector(

      'AddressCountryNew',

      'AddressProvinceNew',

      {
        hideElement:
          'AddressProvinceContainerNew'
      }

    );

  }


  $('.address-country-option')
    .each(
      function() {

        var formId =
          $(this).data(
            'form-id'
          );


        var countrySelector =
          'AddressCountry_' +
          formId;


        var provinceSelector =
          'AddressProvince_' +
          formId;


        var containerSelector =
          'AddressProvinceContainer_' +
          formId;


        new Shopify.CountryProvinceSelector(

          countrySelector,

          provinceSelector,

          {
            hideElement:
              containerSelector
          }

        );

      }
    );


  $('.address-new-toggle').on(
    'click',
    function() {

      $newAddressForm.toggleClass(
        'hide'
      );

    }
  );


  $('.address-edit-toggle').on(
    'click',
    function() {

      var formId =
        $(this).data(
          'form-id'
        );


      $(
        '#EditAddress_' +
        formId
      ).toggleClass(
        'hide'
      );

    }
  );


  $('.address-delete').on(
    'click',
    function() {

      var $el =
        $(this);


      var formId =
        $el.data(
          'form-id'
        );


      var confirmMessage =
        $el.data(
          'confirm-message'
        );


      if (
        confirm(
          confirmMessage ||
          'Are you sure you wish to delete this address?'
        )
      ) {

        Shopify.postLink(

          '/account/addresses/' +
          formId,

          {
            parameters: {
              _method:
                'delete'
            }
          }

        );

      }

    }
  );

})();


/**
 * Password Template Script
 * -----------------------------------------------------------------------------
 */

theme.customerLogin =
(function() {

  var config = {

    recoverPasswordForm:
      '#RecoverPassword',

    hideRecoverPasswordLink:
      '#HideRecoverPasswordLink'

  };


  if (
    !$(config.recoverPasswordForm)
      .length
  ) {
    return;
  }


  checkUrlHash();

  resetPasswordSuccess();


  $(
    config.recoverPasswordForm
  ).on(
    'click',
    onShowHidePasswordForm
  );


  $(
    config.hideRecoverPasswordLink
  ).on(
    'click',
    onShowHidePasswordForm
  );


  function onShowHidePasswordForm(
    evt
  ) {

    evt.preventDefault();

    toggleRecoverPasswordForm();

  }


  function checkUrlHash() {

    var hash =
      window.location.hash;


    if (
      hash ===
      '#recover'
    ) {

      toggleRecoverPasswordForm();

    }

  }


  function toggleRecoverPasswordForm() {

    $('#RecoverPasswordForm')
      .toggleClass(
        'hide'
      );


    $('#CustomerLoginForm')
      .toggleClass(
        'hide'
      );

  }


  function resetPasswordSuccess() {

    var $formState =
      $('.reset-password-success');


    if (
      !$formState.length
    ) {
      return;
    }


    $('#ResetSuccess')
      .removeClass(
        'hide'
      );

  }

})();


/* ============================================================
   DOCUMENT READY
   ============================================================ */

$(document).ready(
  function() {


    const headerHeight =
      $('.header').height();


    const $mainContent =
      $('#MainContent');


    $mainContent.css({
      'margin-top':
        headerHeight
    });


    setTimeout(
      function() {

        $mainContent.addClass(
          'content--reveal'
        );

      },
      100
    );


    var sections =
      new slate.Sections();


    sections.register(
      'product',
      theme.Product
    );


    slate.a11y.pageLinkFocus(
      $(window.location.hash)
    );


    $('.in-page-link').on(
      'click',
      function(evt) {

        slate.a11y.pageLinkFocus(
          $(
            evt.currentTarget.hash
          )
        );

      }
    );


    /* INIT CART */

    slate.cart.cart();


    /* ============================================================
       RESPONSIVE RTE
       ============================================================ */

    var tableSelectors =
      '.rte table';


    slate.rte.wrapTable({

      $tables:
        $(tableSelectors),

      tableWrapperClass:
        'rte__table-wrapper'

    });


    var iframeSelectors =

      '.rte iframe[src*="youtube.com/embed"],' +

      '.rte iframe[src*="player.vimeo"]';


    slate.rte.wrapIframe({

      $iframes:
        $(iframeSelectors),

      iframeWrapperClass:
        'rte__video-wrapper'

    });


    /* ============================================================
       PRODUCT SLIDER
       ============================================================ */

    const productInfoSpacing =
      30;


    const $productImageSlider =
      $('.product__images-slider');


    const numOfThumbnails =
      $('.product__images-thumbs > img')
        .length;


    let slickCenterMode =
      false;


    if (
      numOfThumbnails >=
      4
    ) {

      slickCenterMode =
        true;

    }


    if (
      $productImageSlider.length
    ) {

      $productImageSlider.slick({

        slidesToShow:
          1,

        slidesToScroll:
          1,

        fade:
          true,

        prevArrow:
          '<span class="fas fa-chevron-left arrow--left"></span>',

        nextArrow:
          '<span class="fas fa-chevron-right arrow--right"></span>'

      });

    }


    if (
      numOfThumbnails >
      1
    ) {

      $('.product__images-thumbs')
        .slick({

          slidesToShow:
            4,

          slidesToScroll:
            2,

          arrows:
            false,

          centerMode:
            slickCenterMode,

          focusOnSelect:
            true,

          asNavFor:
            '.product__images-slider'

        });

    }


    /* ============================================================
       SALES POP
       ============================================================ */

    const $salesPop =
      $('.sales-pop__box');


    const $salesPopContainer =
      $('.sales-pop');


    const $salesPopData =
      $('.sales-pop__data');


    const $salesPopName =
      $('.sales-pop__name');


    const $salesPopLocation =
      $('.sales-pop__location');


    const $salesPopTimestamp =
      $('.sales-pop__timestamp');


    let salesPopNames =
        false,

      salesPopLocations =
        false,

      salesPopTimestamps =
        false;


    if (
      $salesPop.length
    ) {

      salesPopNames =
        $salesPopData
          .attr(
            'data-names'
          )
          .split(',');


      salesPopLocations =
        $salesPopData
          .attr(
            'data-locations'
          )
          .split(',');


      salesPopTimestamps =
        $salesPopData
          .attr(
            'data-timestamp'
          )
          .split(',');

    }


    const isRandom =
      $salesPopData.attr(
        'data-selection'
      ) == 'random'
        ? true
        : false;


    const activeClass =
      'active';


    let numOfLocations =
      salesPopLocations.length -
      1;


    let cycleNotification;


    let salesPopIndex =
      0;


    let indexArr =
      [];


    if (
      $salesPop.length
    ) {

      startSalesPop(
        $salesPop
      );


      const $closeSalesPop =
        $('.sales-pop__close');


      $closeSalesPop.click(
        function() {

          $salesPop.addClass(
            'hidden'
          );


          $salesPopContainer.removeClass(
            activeClass
          );


          clearInterval(
            cycleNotification
          );

        }
      );

    }


    function startSalesPop(
      $elem
    ) {

      const delayShow =
        setTimeout(
          function() {

            let index =
              0;


            numOfLocations =
              salesPopLocations.length -
              1;


            if (isRandom) {

              index =
                Math.floor(

                  Math.random() *
                  numOfLocations

                );

            }


            if (
              salesPopNames.length
            ) {

              $salesPopName.text(
                salesPopNames[index]
              );

            } else {

              $salesPopName.text(
                'Someone'
              );

            }


            $salesPopLocation.text(
              salesPopLocations[index]
            );


            $salesPopTimestamp.text(
              salesPopTimestamps[index]
            );


            salesPopNames.splice(
              index,
              1
            );


            salesPopLocations.splice(
              index,
              1
            );


            salesPopTimestamps.splice(
              index,
              1
            );


            $salesPop.addClass(
              activeClass
            );


            $salesPopContainer.addClass(
              activeClass
            );


            const delayHide =
              setTimeout(
                function() {

                  $salesPop.removeClass(
                    activeClass
                  );


                  const delayZIndex =
                    setTimeout(
                      function() {

                        $salesPopContainer.removeClass(
                          activeClass
                        );

                      },
                      750
                    );

                },
                10000
              );


            swapSalesPop();

          },
          15000
        );

    }


    function swapSalesPop(
      swap
    ) {

      cycleNotification =
        setInterval(
          function() {

            if (
              salesPopLocations.length
            ) {

              let index =
                0;


              numOfLocations =
                salesPopLocations.length -
                1;


              if (isRandom) {

                index =
                  Math.floor(

                    Math.random() *
                    numOfLocations

                  );

              }


              if (
                salesPopNames.length
              ) {

                $salesPopName.text(
                  salesPopNames[index]
                );

              } else {

                $salesPopName.text(
                  'Someone'
                );

              }


              $salesPopLocation.text(
                salesPopLocations[index]
              );


              $salesPopTimestamp.text(
                salesPopTimestamps[index]
              );


              salesPopNames.splice(
                index,
                1
              );


              salesPopLocations.splice(
                index,
                1
              );


              salesPopTimestamps.splice(
                index,
                1
              );


              $salesPop.addClass(
                activeClass
              );


              $salesPopContainer.addClass(
                activeClass
              );


              const transitionOut =
                setTimeout(
                  function() {

                    $salesPop.removeClass(
                      activeClass
                    );


                    const delayZIndex =
                      setTimeout(
                        function() {

                          $salesPopContainer.removeClass(
                            activeClass
                          );

                        },
                        750
                      );

                  },
                  10000
                );

            } else {

              $salesPop.addClass(
                'hidden'
              );


              $salesPopContainer.removeClass(
                activeClass
              );


              clearInterval(
                cycleNotification
              );

            }

          },
          25000
        );

    }


    /* ============================================================
       POPUPS
       ============================================================ */

    const $popupFloat =
      $('.pop-up-float');


    const $popupModal =
      $('.pop-up-modal');


    const $popupModalClose =
      $('.pop-up-modal__close--trigger');


    const $popupFloatClose =
      $('.pop-up-float__close');


    const $triggerPopupContainer =
      $('.pop-up-trigger');


    const $triggerPopup =
      $('.pop-up-trigger__trigger');


    const $triggerPopupClose =
      $('.pop-up-trigger__close');


    const popupActiveClass =
      'active';


    const popUpDelay =
      parseInt(
        $popupModal.attr(
          'data-delay'
        )
      ) *
      1000;


    if (
      document.cookie.indexOf(
        'promo-pop-up-float'
      ) == -1 &&
      $triggerPopupContainer.length
    ) {

      $triggerPopupContainer.addClass(
        popupActiveClass
      );

    }


    if (
      document.cookie.indexOf(
        'promo-pop-up-modal'
      ) == -1 &&
      $popupModal.length
    ) {

      setTimeout(
        function() {

          document.cookie =
            'promo-pop-up-modal=true';


          $popupModal.addClass(
            popupActiveClass
          );

        },
        popUpDelay
      );

    }


    $triggerPopup.click(
      function() {

        $popupFloat.addClass(
          popupActiveClass
        );

      }
    );


    $popupFloatClose.click(
      function() {

        $popupFloat.removeClass(
          popupActiveClass
        );

      }
    );


    $triggerPopupClose.click(
      function() {

        $triggerPopupContainer.removeClass(
          popupActiveClass
        );


        document.cookie =
          'promo-pop-up-float=true';

      }
    );


    $popupModalClose.click(
      function() {

        document.cookie =
          'promo-pop-up-modal=true';


        $popupModal.hide();

      }
    );


    $popupModal.find(
      'form'
    ).submit(
      function() {

        $popupFloat.hide();

        $triggerPopupContainer.hide();

        document.cookie =
          'promo-pop-up-float=true';

      }
    );


    /* ============================================================
       LAZY IMAGES
       ============================================================ */

    $(".lazy").Lazy({

      afterLoad:
      function($element) {

        $element.addClass(
          "lazyloaded"
        );

      }

    });


    /* ============================================================
       COOKIE SUPPORT CLASS
       ============================================================ */

    if (
      slate.cart.cookiesEnabled()
    ) {

      document.documentElement.className =

        document.documentElement.className.replace(

          'supports-no-cookies',

          'supports-cookies'

        );

    }

  }
);